import { HttpContextToken } from '@angular/common/http';
import { RegionKey } from './env-utils';

export const USE_STATS_BASE = new HttpContextToken<boolean>(() => false);
export const USE_SEO_BASE = new HttpContextToken<boolean>(() => false);
export const USE_BUGS_BASE = new HttpContextToken<boolean>(() => false);
export const REQUIRE_SHIFT_DATES = new HttpContextToken<boolean>(() => false);
export const EXPECTS_CSV = new HttpContextToken<boolean>(() => false);
export const EXPECTS_XLSX = new HttpContextToken<boolean>(() => false);
export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);
export const USE_MODEL_AUTOMATION_BASE = new HttpContextToken<boolean>(
  () => false,
);
export const USE_ADS_BASE = new HttpContextToken<boolean>(() => false);
export const USE_GOLIVE_BASE = new HttpContextToken<boolean>(() => false);
export const FORCE_REGION = new HttpContextToken<RegionKey | null>(() => null);
